import CloseNotification from './component'

export default CloseNotification